import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SummaryParent} from '@app/wrappers/summary-parent';
import {Divider} from 'primeng/divider';
import {News} from '@components/ui/news/news';
import {MainStatusTag} from '@components/ui/main-status-tag/main-status-tag';
import {AuthService} from '@services/auth.service';
import {ThemeModule} from '@app/themes/theme-module';
import {IMenuItem} from '@models/i-menu-item';
import {MENU_ITEMS} from '@shared/config/menu';
import {environment} from '@root/src/environments/environment';

@Component({
  selector: 'app-homePage-page',
  standalone: true,
  imports: [CommonModule, TranslateModule,ThemeModule, Divider, News, MainStatusTag],
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent extends SummaryParent implements OnInit {
  isDarkTheme = false;

  items: IMenuItem[] = [];

  private readonly allItems: IMenuItem[] = MENU_ITEMS;

  constructor(
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {
    super();
    this.isDarkTheme = document.body.classList.contains('dark-theme');
  }

  ngOnInit(): void {
    this.items = this.authService.isAdmin()
      ? [...this.allItems]
      : this.allItems.filter((item) => item.title !== 'Administration');

    const observer = new MutationObserver(() => {
      this.isDarkTheme = document.body.classList.contains('dark-theme');
      this.cdr.detectChanges();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  getIconPath(iconName: string): string {
    const theme = this.isDarkTheme ? 'dark' : 'light';
    return `assets/icons/main/${theme}/ico-${iconName}.svg`;
  }

  protected readonly environment = environment;
}
